module.exports = {
      id: "online-news-usage",
      viewBox: "0 0 56.84 35.647",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#online-news",
      toString: function () {
        return this.url;
      }
    }